module.exports = __webpack_public_path__ + "img/bImg3.449435c4.png";